import React, { useCallback, useEffect, useState } from 'react';
import { Mail, MessageSquare } from 'lucide-react';
import * as api from '../utils/channelsApi';
import { AccountEmailTemplatesSection } from './templates/AccountEmailTemplatesSection';
import { AccountChannelMessagesSection } from './templates/AccountChannelMessagesSection';
import { SegmentedToggle } from './templates/templateUI';

const VIEWS = [
    { value: 'email', label: 'Email', icon: Mail },
    { value: 'channel', label: 'Channel', icon: MessageSquare },
];

function UniversalFooter({ state }) {
    return (
        <section className="manager-card templates-footer-card">
            <header className="manager-card__head">
                <div>
                    <h3>Universal footer</h3>
                    <p>Appended to every survey email. Authors cannot remove or replace it.</p>
                </div>
                <span className="manager-status">Always included</span>
            </header>
            <div className="standard-footer-preview">
                <strong>{state?.owner_name || state?.organization_name || 'Organization account owner'}</strong>
                <p>{state?.contact_url || 'Organization Contact URL not set'}</p>
                <p>This email was sent through SamSurveyor and does not accept replies.</p>
            </div>
        </section>
    );
}

/**
 * Channels owns the universal-footer policy, then embeds the authoritative
 * Console Templates feature without a second, divergent implementation.
 */
export default function TemplatesPanel({ state, organizationId, canPersist = true, onNotice }) {
    const [view, setView] = useState('email');
    const [org, setOrg] = useState(null);

    useEffect(() => {
        let alive = true;
        if (!organizationId) return undefined;
        api.getOrganization(organizationId)
            .then(value => { if (alive) setOrg(value); })
            .catch(() => { /* signed-out localhost has no organization data */ });
        return () => { alive = false; };
    }, [organizationId]);

    const renderToggle = useCallback((locked) => (
        <SegmentedToggle
            value={view}
            onChange={setView}
            options={VIEWS}
            disabled={locked}
            disabledHint="Save or cancel your edit first"
        />
    ), [view]);

    return (
        <div className="templates-manager templates-manager--full">
            <UniversalFooter state={state} />
            <section className="manager-card template-editor-card">
                {view === 'email'
                    ? <AccountEmailTemplatesSection orgId={organizationId} org={org} canPersist={canPersist} renderToggle={renderToggle} onNotice={onNotice} />
                    : <AccountChannelMessagesSection orgId={organizationId} org={org} canPersist={canPersist} renderToggle={renderToggle} onNotice={onNotice} />}
            </section>
        </div>
    );
}
